export const shipmentTableDefaultColumns = [
  { id: 'status', label: 'Status', isVisible: true, disabled: false },
  { id: 'alert', label: 'Alert', isVisible: true, disabled: false },
  { id: 'label', label: 'Shipment', isVisible: true, disabled: true, root: true },
  { id: 'devices', label: 'Devices', isVisible: true, disabled: false },
  { id: 'project', label: 'Project', isVisible: true, disabled: false },
  { id: 'startDate', label: 'Start', isVisible: true, disabled: false },
  { id: 'endDate', label: 'Due', isVisible: true, disabled: false },
  { id: 'download', label: 'Download PDF report', isVisible: true, disabled: false }
];
